import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const pageVariants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.35, ease: [0.25, 0.1, 0.25, 1] } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.2 } }
};

export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div key={location.pathname} variants={pageVariants} initial="initial" animate="animate" exit="exit">
        {children}
      </motion.div>
    </AnimatePresence>
  );
}

// Reusable stagger container
export const StaggerContainer = ({ children, className = '', delay = 0 }) => (
  <motion.div className={className}
    initial="hidden" animate="visible"
    variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.08, delayChildren: delay } } }}>
    {children}
  </motion.div>
);

// Reusable fade-up item
export const FadeUp = ({ children, className = '', delay = 0 }) => (
  <motion.div className={className}
    variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1], delay } } }}>
    {children}
  </motion.div>
);

// Scale on hover wrapper
export const HoverScale = ({ children, className = '', scale = 1.03 }) => (
  <motion.div className={className}
    whileHover={{ scale, transition: { duration: 0.2 } }}
    whileTap={{ scale: 0.98 }}>
    {children}
  </motion.div>
);

// Animated counter for numbers
export const AnimatedNumber = ({ value, className = '' }) => (
  <motion.span className={className}
    initial={{ opacity: 0, scale: 0.5 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ type: 'spring', stiffness: 200, damping: 15 }}>
    {value}
  </motion.span>
);

// Glow pulse for important elements
export const GlowPulse = ({ children, color = 'purple', className = '' }) => (
  <motion.div className={className}
    animate={{ boxShadow: [`0 0 20px rgba(168,85,247,0.2)`, `0 0 40px rgba(168,85,247,0.4)`, `0 0 20px rgba(168,85,247,0.2)`] }}
    transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}>
    {children}
  </motion.div>
);
